import { useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useAppDispatch } from "@/store/hooks";
import { insertInquiry } from "@/services/home.services";
import { toast } from "sonner";
import { useRouter } from "next/navigation";
import { parseQueryParams } from "@/_helper/helper";

export const inquiryValidationSchema = Yup.object({
  FirstName: Yup.string().required("Name is required"),
  MobileNo: Yup.string()
    .matches(/^[0-9+\s-]{10,15}$/, "Invalid phone number")
    .required("Phone number is required"),
  Email: Yup.string()
    .email("Invalid email address")
    .required("Email is required"),
  CheckIn: Yup.date().nullable(),
  CheckOut: Yup.date().nullable(),
  Remarks: Yup.string().required("Message is required"),
});

export interface IInquiryFormValues {
  FirstName: string;
  MobileNo: string;
  Email: string;
  CheckIn: string;
  DiningID?: number | null;
  Adults?: number | null;
  CheckInTime: string;
  CheckOut: string;
  Remarks: string;
  Type: string;
  PropertyURL?: string;
}

export const useInquiryForm = (
  inquiryType: string = "Contact",
  validationSchema: Yup.ObjectSchema<any, any> = inquiryValidationSchema,
) => {
  const searchParams =
    typeof window !== "undefined"
      ? parseQueryParams(window.location.search)
      : null;
  const router = useRouter();
  const dispatch = useAppDispatch();
  const [submitted, setSubmitted] = useState(false);

  const formik = useFormik<IInquiryFormValues>({
    initialValues: {
      FirstName: "",
      MobileNo: "",
      Email: "",
      CheckIn: "",
      CheckInTime: "",
      CheckOut: "",
      Adults: null,
      DiningID: null,
      Remarks: "",
      Type: inquiryType,
      PropertyURL: "",
    },
    validationSchema: validationSchema,
    onSubmit: async (values, { setSubmitting, resetForm }) => {
      const payload = {
        FirstName: values.FirstName,
        MobileNo: values.MobileNo,
        Email: values.Email,
        CheckIn: values.CheckIn || null,
        CheckOut: values.CheckOut || null,
        Remarks: values.Remarks,
        InquiryType: values.Type,
        CheckInTime: values.CheckInTime || "",
        DiningID: values.DiningID ? +values.DiningID : null,
        Adults: values.Adults ? `${values.Adults}` : "",
        PropertyURL: values.PropertyURL || "",
        source: searchParams?.utm_source ? searchParams?.utm_source : "",
        medium: searchParams?.utm_medium ? searchParams?.utm_medium : "",
        campaign: searchParams?.utm_campaign ? searchParams?.utm_campaign : "",
        utmContent: searchParams?.utm_content ? searchParams?.utm_content : "",
      };
      try {
        await dispatch(insertInquiry(payload)).unwrap();

        // toast.success("Inquiry submitted successfully!");
        setSubmitted(true);
        resetForm();
        setTimeout(() => {
          router.push("/thank-you");
        }, 2000);
      } catch (error: any) {
        toast.error(error.message || "Failed to submit inquiry");
      } finally {
        setSubmitting(false);
      }
    },
  });

  return {
    formik,
    submitted,
    setSubmitted,
  };
};
